import { AntTag, Icons, Text } from '@agro-club/agroclub-shared'
import { Contact } from 'modules/domain/user/types'
import { Company } from 'modules/domain/company/types'
import { Pagination } from 'views/components/Pagination/Pagination'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { Card } from 'views/components/Card/Card'
import { refetchFunc, usePagination, useSingleEntity } from 'modules/domain/common/hooks'
import { endpoints } from 'modules/endpoints'
import { FIVE_ITEM_PAGE_SIZE } from 'modules/constants'
import { CompanyLink } from 'views/components/CompanyLink/CompanyLink'
import { AButton } from 'views/components/Analytics'
import { useAProgress } from 'hooks/useAProgress'
import { apiClient } from 'modules/utils/httpClient'
import { RemoveBranchModal } from './RemoveBranchModal'
import { CompanyContact } from './CompanyContact'
import { Hr } from 'views/components/Hr/Hr'

const CompanyInfoWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const BtnsWrapper = styled.div`
  display: flex;
  gap: 8px;
`
const UsersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 10px;
`

type Props = {
  branch: Company
  isMain?: boolean
  isCurrent?: boolean
  refetch: refetchFunc
}
export const CompanyBranch: FC<Props> = ({ branch, isMain, isCurrent, refetch }) => {
  const { t } = useTranslation('company')
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [, contacts = []] = useSingleEntity<Contact[]>(endpoints.companyContacts(branch.id), false)
  const [contactsCurrentPage, setContactsCurrentPage, contactsCurrentItems] = usePagination(
    contacts,
    FIVE_ITEM_PAGE_SIZE,
  )
  const [progress, makeParent] = useAProgress(async () => await apiClient.post(endpoints.makeGroupParent(branch.id)), {
    eventName: 'makeGroupParent',
    onSuccess: () => refetch(),
  })

  return (
    <Card.Container bordered>
      {isMain && <Text color="secondary"> {t('mainCompany')} </Text>}
      <Card.GapableContent>
        <CompanyInfoWrapper>
          <div>
            <Card.Title>
              <CompanyLink company={branch} />
            </Card.Title>
            <Text color="secondary">
              {`${t('common:inn')}: `}
              {branch.inn}
            </Text>
          </div>
          <BtnsWrapper>
            {!isMain && (
              <>
                <AButton
                  id="makeMain"
                  progress={progress}
                  onClick={makeParent}
                  color="secondary"
                  border="solid"
                  background="none"
                >
                  {t('makeMain')}
                </AButton>
                <AButton
                  id="removeCompanyFromGroup"
                  Icon={Icons.IconClose}
                  onClick={() => setShowDeleteModal(true)}
                  color="secondary"
                  border="solid"
                  background="none"
                />
              </>
            )}
          </BtnsWrapper>
        </CompanyInfoWrapper>
        <div>
          {isCurrent && <AntTag color="white">{t('currentCompany')}</AntTag>}
          <UsersWrapper>
            {contactsCurrentItems.length > 0 && <Hr />}
            {contactsCurrentItems.map((contact, index) => (
              <CompanyContact key={index} contact={contact} />
            ))}
          </UsersWrapper>
          <Pagination total={contacts.length} currPage={contactsCurrentPage} setCurrPage={setContactsCurrentPage} />
        </div>
      </Card.GapableContent>
      {showDeleteModal && (
        <RemoveBranchModal onClose={() => setShowDeleteModal(false)} branch={branch} onSuccess={refetch} />
      )}
    </Card.Container>
  )
}
